import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomgridModel, CustomgridParam, CustomgridSQL, CustomgridXml, HtmlBase, PropertyData, QueovalItemModel } from '../../../../models';
import { CoreService, HttpService } from '../../../../services';
import { ToastService } from '../../../../toast/toast.service';
import { b64UrlEncodeUnicode } from '../../../../utilities';
import { BaseAddOnComponent } from '../base-addon.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-email',
  templateUrl: './email.component.html',
  styleUrls: ['./email.component.css', '../../dynamictag.component.css']
})

export class EmailComponent extends BaseAddOnComponent {
  public modalLoading: boolean = false;
  public customgridParam: CustomgridModel;

  @Input('input') input: PropertyData;
  @Output() navig: EventEmitter<HtmlBase> = new EventEmitter<HtmlBase>(true);

  constructor(
    private http: HttpService,
    private indParam: CoreService,
    private modalService: NgbModal,
    private toastservice: ToastService,
    public sanitizer: DomSanitizer,
  ) { super(); }

 

  public OnButtonClicked(button: HtmlBase, content: any): void {
    switch (button.TypeModal) {
      case 'MODAL':
        this.modalLoading = true;
        const val = b64UrlEncodeUnicode(`${this.input.MainElementList[0].Value}|${this.input.QueovalCode.toUpperCase()}_${this.input.MainElementList[0].ID}`);
        this.http.getHttp<QueovalItemModel>(`${this.indParam.AppParams.apiUrl}api/queovalitem/getData/HISTO_SIB/${val}`).subscribe(
          (result: QueovalItemModel) => {

            this.customgridParam = new CustomgridModel();
            this.customgridParam.GridXml = new CustomgridXml();
            this.customgridParam.GridXml.rowData = new CustomgridSQL();
            this.customgridParam.cgParameters = new CustomgridParam();
            this.customgridParam.cgParameters.FileName = `${this.input.QueovalCode.toUpperCase()}_${this.input.MainElementList[0].ID}`;
            this.customgridParam.GridXml.columnDefs = result.columnDefs;
            this.customgridParam.GridXml.rowData.data = JSON.stringify(result.rowData);
            this.customgridParam.cgParameters.isDataLoaded = true;

        
          this.modalLoading = false;
        
         });
        this.modalService.open(content, { size: 'xl', centered: true, windowClass: 'modal-email qmodalover' }).result.then((modalResult) => {
          switch (modalResult) {
            //  case 'SAVE': this.saveConfigSignature(); break;
            //  case 'CANCEL': this.closeConfigSignature(); break;
          }
        });
        break;
      case "MAIL":
        const regex: RegExp = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
        const validation: boolean = regex.test(this.input.MainElementList[0].Value);
        if (validation) {
          window.open(`${button.OnClick}${this.input.MainElementList[0].Value}`, '_blank');
        } else this.toastservice.showWarningToast('l\'adresse mail n\'est pas valide');
        break;
      default:
        this.navig.emit(button);
    }
  }

}
